<form [name]="form" [formGroup]="form">
    <div fxLayout="column" fxLayoutAlign="start">
        <ng-container *ngIf="haveConfigAsignaciones">
            <div fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-around stretch"
                 fxLayoutAlign.sm="space-around stretch" fxLayoutAlign.xs="space-around stretch">
                <mat-form-field appearance="outline" fxFlex="100%" class="px-4">
                    <mat-label>Unidad</mat-label>
                    <input matInput formControlName="unidadDestino" [matAutocomplete]="autoOrgAsignacion"
                           (focusout)="cleanValuesUsuarioAsignacion($event)"
                           [required]="form.get('unidadDestino').errors !== null && form.get('unidadDestino').errors.required"
                    >
                    <mat-icon matSuffix>arrow_drop_down</mat-icon>
                    <mat-autocomplete #autoOrgAsignacion="matAutocomplete" [displayWith]="displayFn"
                                      (optionSelected)="getUsuariosByIdOrganizacion($event.option.value)">
                        <mat-option *ngFor="let option of organizacionFilterOption$ | async" [value]="option">
                            <span style="height: content-box; display: block;">{{option.label}}</span>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
        </ng-container>
        <div fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-around stretch"
             fxLayoutAlign.sm="space-around stretch" fxLayoutAlign.xs="space-around stretch">
            <mat-form-field appearance="outline" fxFlex="100%" class="px-4">
                <mat-label>{{labelInput}}</mat-label>
                <input matInput formControlName="usuarioDestino" [matAutocomplete]="autoUsuarioAsignacion"
                       [required]="form.get('usuarioDestino').errors !== null && form.get('usuarioDestino').errors.required"
                >
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                <mat-autocomplete #autoUsuarioAsignacion="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let option of usuarioFilterOption$ | async" [value]="option">
                        <span>{{option.label}}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
    </div>
</form>
